import styles from './Sitemap.module.css'
import NavMenu from './NavMenu/NavMenu';
import LojasApp from './LojasApp/LojasApp';
import ListaProdutos from './ListaProdutos/ListaProdutos';
import RedesSociais from './RedesSociais/RedesSociais';
import MenuAuxiliar from './MenuAuxiliar/MenuAuxiliar';
import Link from "next/link";

const Sitemap = () => {
    return (
      <section className={styles.Sitemap}>
        <div className='uiContainer'>
          <div className={styles.containerLogos}>
            <div className={styles.itemLogos}>
              <Link
                  href="https://www.bvirtual.com.br/"
                  aria-label="Acessar Página BVirtual (abre em nova aba)"
                  target="_blank"
				  rel="noopener noreferrer"
                >
                  <img src="/images/logoPadraoFooter.svg" alt="Logo Biblioteca Virtual" width={154} height={62} loading="lazy" />
              </Link>
            </div>
            <div className={styles.itemLogos}>  
              <Link
                  href="https://br.pearson.com/"
                  aria-label="Acessar Página Pearson (abre em nova aba)"
                  target="_blank"
				  rel="noopener noreferrer"
                >  
              <svg id="LOGO" width={160} height={160} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2411.36 892.84">
                <g>
                  <path className="cls-1" fill="#0d004d" d="M365.27,293.02v.06s7.39,56.57,7.39,153.13-7.39,153.19-7.39,153.12v.06c37.77-40.09,60.94-93.93,60.94-153.17v-.03c0-59.24-23.17-113.08-60.94-153.17Z"/>
                  <path className="cls-1" fill="#0d004d" d="M366.6,394.43c-7.92-29.94-22.75-58.15-43.29-83.78-17.62-19.79-39.01-37.06-63.25-51.07,23.51,37.16,39.33,106.66,39.33,186.27s-15.79,148.95-39.25,186.15c-.18.42-.37.84-.55,1.26,13.52-7.78,26.16-16.57,37.75-26.25,40.01-38.08,66.33-83.78,73.72-133.49,1.06-8.86,1.61-17.88,1.61-27.03h0c0-17.93-2.1-35.35-6.06-52.07Z"/>
                </g>
                <g>
                  <path className="cls-1" fill="#0d004d" d="M1772.62,373.65c-75.23,0-135.17,58.93-135.17,133.09s59.75,132.85,134.98,132.85,134.98-58.75,134.98-132.9-59.57-133.03-134.8-133.03ZM1772.44,579.84c-43.23,0-69.89-33.61-69.89-73.1s26.67-73.15,69.89-73.15,69.89,33.61,69.89,73.1-26.67,73.15-69.89,73.15Z"/>
                  <path className="cls-1" fill="#0d004d" d="M826.45,373.67c-74.61,0-128.55,60.24-128.56,133.44,0,71.62,51.62,132.63,126.57,132.63,54.08,0,103.31-32.43,121.91-82.94h-65.64c-10.17,13.52-30.09,25-55.86,25-41.07,0-59.74-29.32-61.9-51.71h187.72c1.1-7.21,1.7-19.18,1.7-27.5,0-77.53-57.04-128.92-125.94-128.92ZM763.12,481.22c0-27.75,27.36-50.23,61.1-50.23s61.12,22.49,61.12,50.23h-122.23Z"/>
                  <path className="cls-1" fill="#0d004d" d="M2037.18,373.68c-63.36,0-114.57,51.18-114.57,114.56v145.02h64.24l.02-144.93c0-32.75,23.26-53.62,50.21-53.62,26.93,0,50.06,21.03,50.03,53.79l-.13,144.76h64.79v-144.98c.01-63.38-51.22-114.6-114.59-114.6Z"/>
                  <path className="cls-1" fill="#0d004d" d="M1431.05,381.76c-7.09-3.32-22.48-8.09-40.05-8.09-50.65,0-70.34,38.98-72.52,43.3v-36.82h-60.82l-.17,253.07,64.2.03v-165.59c1.76-3.42,19.78-34.16,57.09-34.16,13.95,0,26.65,4.3,29.87,5.87l22.41-57.62Z"/>
                  <path className="cls-1" fill="#0d004d" d="M1100.52,373.65c-74.69,0-135.42,58.28-135.42,134.2,0,71.09,53.25,132.03,125.22,131.88,36.23-.07,64.81-15.6,79.67-38.11v31.64h65.04s-.05-129.86-.05-129.86c-.03-73.17-60.85-129.75-134.45-129.75ZM1100.08,580.69c-43.23,0-69.9-34.11-69.9-73.6s26.68-73.6,69.9-73.6,69.9,34.11,69.9,73.6-26.68,73.6-69.9,73.6Z"/>
                  <path className="cls-1" fill="#0d004d" d="M1546.9,482.16c-42.68-9.08-59.75-12.82-59.75-27.33,0-16.42,21.88-24.97,44.97-24.97,35.06,0,60.98,19.69,63.86,21.88l32-46.96c-16.38-10.98-47.53-31.12-96.44-31.12-67.9,0-107.38,38.66-107.38,81.77,0,45.38,43.73,66.82,93.91,77.39,38.39,8.09,50.15,11.2,50.15,24.75,0,18.48-21.88,25.94-44.15,25.94-34.35,0-62.85-17.75-80.15-36.26l-35.74,46.41c14.91,14.18,53.51,46.05,114.8,46.05s109.82-34.86,109.82-78.08c0-52.28-35.75-68.82-85.9-79.49Z"/>
                  <path className="cls-1" fill="#0d004d" d="M591.01,259.58h-126.76l-.04,373.68h63.79l.05-134.64h62.96c74.16,0,123.77-51.21,123.77-119.52s-49.61-119.52-123.77-119.52ZM583,437.79h-54.95v-117.38h54.95c43.75,0,66.7,23.48,66.7,58.69s-22.95,58.69-66.7,58.69Z"/>
                </g>
              </svg>
              </Link>  
            </div>
          </div>

          <div className={styles.dFlex}>
            <div className={styles.col}>
              <NavMenu/>   

              <LojasApp/>        
            </div>

            <div className={styles.col}>
              <ListaProdutos/>
            </div>
          </div>

          <div className={styles.navFooter}>
              <RedesSociais/>

              <MenuAuxiliar/>
          </div>
        </div>
      </section>
    );
  };
  
  export default Sitemap;